module.exports = __webpack_public_path__ + "media/images/admin/icons/sidebar-79c7aba125a90e93fa7ec267b8da7c01.svg";